import React, { forwardRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';

// eslint-disable-next-line prefer-arrow-callback
const Card = forwardRef(function Card({
  children,
  className,
}, ref) {
  return (
    <div ref={ref} className={cx('hms-card', className)}>
      {children}
    </div>
  );
});

Card.propTypes = {
  children: T.node.isRequired,
  className: T.string,
};

export default Card;
